import ServiceCardList, { ServiceCardListProps } from './ServiceCardList';

export type { ServiceCardListProps };
export default ServiceCardList;
